<kodit-dropdown
  (optionChanged)="handleOnItemChange($event)"
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Tip akcizne kategorije"
  [formCtrl]="formCtrl"
></kodit-dropdown>
